
export const getFullDate = (date) => {
    const dateAndTime = date.split('T');

    let tm = dateAndTime[1].split('\.')[0];
    
    return dateAndTime[0].split('-').reverse().join('-') + ' ' + tm ;
};
